import { render, staticRenderFns } from "./SessionComponent.vue?vue&type=template&id=f5e1e2a0"
import script from "./SessionComponent.vue?vue&type=script&lang=js"
export * from "./SessionComponent.vue?vue&type=script&lang=js"
import style0 from "./SessionComponent.vue?vue&type=style&index=0&id=f5e1e2a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports